import { CallMethodEnums } from '@/types/api';
import {
  CreateApiKeyReq,
  CreateApiKeyRes,
  DeleteApiKeyRes,
  DisableApiKeyRes,
  EnableApiKeyRes,
  GetApiKeysRes
} from '@/types/apiKey';

import { call } from './utils';

export const apiKeyCreate = async( name: string ): Promise<CreateApiKeyRes> => {
  const json = call<CreateApiKeyReq, CreateApiKeyRes>( {
    body: {
      name
    },
    isProtected: true,
    method: CallMethodEnums.POST,
    route: '/api/api_keys'
  } );

  return json;
};

export const apiKeyDelete = async( keyId: string ): Promise<DeleteApiKeyRes> => {
  const json = call<undefined, DeleteApiKeyRes>( {
    isProtected: true,
    method: CallMethodEnums.DELETE,
    route: '/api/api_keys/' + keyId
  } );

  return json;
};

export const apiKeysGet = async(): Promise<GetApiKeysRes> => {
  const json = call<unknown, GetApiKeysRes>( {
    isProtected: true,
    method: CallMethodEnums.GET,
    route: '/api/api_keys'
  } );

  return json;
};

export const apiKeyDisable = async( keyId: string ): Promise<DisableApiKeyRes> => {
  const json = call<undefined, DisableApiKeyRes>( {
    isProtected: true,
    method: CallMethodEnums.PUT,
    route: '/api/api_keys/' + keyId + '/disable'
  } );

  return json;
};

export const apiKeyEnable = async( keyId: string ): Promise<EnableApiKeyRes> => {
  const json = call<undefined, EnableApiKeyRes>( {
    isProtected: true,
    method: CallMethodEnums.PUT,
    route: '/api/api_keys/' + keyId + '/enable'
  } );

  return json;
};